import { useMatch, useResolvedPath } from 'react-router-dom';

const useSelectedTab = () => {
  const { pathname } = useResolvedPath(':tab/*');
  const match = useMatch(pathname);
  return match?.params?.tab;
};

export default useSelectedTab;
